import { useTranslation } from 'react-i18next';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { isAppLocale, SUPPORTED_LOCALES } from '@/i18n/config';
import { useLocale } from '@/i18n/useLocale';

/**
 * The self-service language setting (SL-0027, Task 12.3, Resolution 5): a `ProfilePage` card
 * alongside `DisplayNameForm`, calling `useLocale().setLocale` — which write-throughs to
 * `PATCH /v1/profile { preferredLanguage }` (Task 12.3) in addition to the immediate local
 * `i18n.changeLanguage` switch. Per Resolution 19, this is one of two language-setting surfaces
 * shipped together — the other is the compact header-level `LanguageSwitcher` (Task 12.4).
 */
export function LanguageSection() {
  const { t } = useTranslation('profile');
  const { locale, setLocale } = useLocale();

  return (
    <Card>
      <CardHeader>
        <CardTitle className="card-label">{t('language.title')}</CardTitle>
      </CardHeader>
      <CardContent>
        <Select
          value={locale}
          onValueChange={(next) => {
            if (isAppLocale(next)) {
              setLocale(next);
            }
          }}
        >
          <SelectTrigger aria-label={t('language.title')}>
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            {SUPPORTED_LOCALES.map((option) => (
              <SelectItem key={option} value={option}>
                {t(`language.${option}`)}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </CardContent>
    </Card>
  );
}
